<template lang="jade">
  .screen_group.unselectable(v-bind:id="'screen'+id")
    .screen.clearfix.no_pad(v-bind:class="{'editable': editable, 'inProfile': inProfile}" v-el:screen)
      img.bg(v-bind:src='imgs[1]')
      .link_mask(v-if='showLink' v-link=" 'layout' ")
      .mask(v-if='!editable')
      #output1.left-top.resizable.no_pad.border(
        data-index='1'
        data-bdColor='1'
        v-bind:class="{'focus': focus1, 'hidden': !focus1 && !inProfile}")
        span.label_group
          span.window_name
            | Output 1
      #output2.right-top.resizable.no_pad.border(
        data-index='2'
        data-bdColor='2'
        v-bind:class="{'focus': focus2, 'hidden': !focus2 && !inProfile}")
        span.label_group
          span.window_name
            | Output 2
      #output3.left-bottom.resizable.no_pad.border(
        data-index='3'
        data-bdColor='3'
        v-bind:class="{'focus': focus3, 'hidden': !focus3 && !inProfile}")
        span.label_group
          span.window_name
            | Output 3
      #output4.right-bottom.resizable.no_pad.border(
        data-index='4'
        data-bdColor='4'
        v-bind:class="{'focus': focus4, 'hidden': !focus4 && !inProfile}")
        span.label_group
          span.window_name
            | Output 4
    .ps_section.col-md-12.no_pad
      span.ps(v-if='showPsOut') Output Resolution: {{outResolutionOptions[outResolution[windowFocus]]}}
      span.ps(v-if="showPsIn") Input Resolution: {{inResolution['1']}}
</template>
<script>
import interact from 'interact.js'
import $ from 'jquery'
import _ from 'lodash'
import { call } from '../Service'

import { mapGetters } from 'vuex'
const FROM_RESIZE = 'fromResize'
const FROM_GESTURE = 'fromGesture'
const FROM_DRAG = 'fromDrag'

export default {
  components: {
  },
  props: {
    showLink: {
      type: Boolean,
      default: false
    },
    inWhichPage: {
      type: String,
      default: 'status'    // status, layout, preset
    },
    id: {
      type: String,
      default: '1'
    },
    showPsOut: {
      type: Boolean,
      default: false
    },
    showPsIn: {
      type: Boolean,
      default: false
    },
    imgs: {
      type: Array,
      default: function () {
        return [
          '',
          require('assets/img/test/output1.jpg'),
          require('assets/img/test/output2.jpg'),
          require('assets/img/test/output3.jpg'),
          require('assets/img/test/output4.jpg')
        ]
      }
    },
    editable: {
      type: Boolean,
      default: true
    },
    apply: {
      type: Function,
      default () {
      }
    },
    resizeEvent: {
      type: Object,
      default () {
        return {}
      },
      twoway: true
    }
  },
  data () {
    return {
      posArray: [],
      bigWidth: 0,
      bigHeight: 0,
      smallWidth: 0,
      smallHeight: 0,
      event: {},
      box: {},
      outLayout: 'init'
    }
  },
  asyncData () {
  },
  computed: {
    inProfile () {
      return this.inWhichPage === 'preset'
    },
    inLayout () {
      return this.inWhichPage === 'layout'
    },
    inStatus () {
      return this.inWhichPage === 'status'
    },
    ...mapGetters({
      // The splits from Mixer API has key 'setting', but unnecessary, but no time to revise,
      // I just remove it from the component Screen.vue, but API still has it.
      splits: 'getSplitArea',
      profiles: 'getProfiles',
      computedSplit: 'getComputedSplit',
      outResolutionOptions: 'getOutResolutionOptions',
      outResolution: 'getOutResolutions',
      inResolution: 'getInResolution',
      isFetching: 'getIsFetching',
      inRatio: 'getInRatio',
      windowFocus: 'getWindowFocus',
      focus1: 'isFocus1',
      focus2: 'isFocus2',
      focus3: 'isFocus3',
      focus4: 'isFocus4',
      is4K: 'getIsInput4k',
      presetRatios: 'getPresetRatios'
    })
  },
  methods: {
    toFocus (windowFocus) {
      this.$store.commit('UPDATE', { type: 'winFocus', windowFocus })
    },
    alert (type, title, content) {
      this.$dispatch('alert', {
        type: type,
        title: title,
        content: content
      })
    },
    handleShowWindow () {
      this.showWindowConfig = true
    },
    interact () {
      const vue = this
      let screen = this.$els.screen

      interact('.focus')
      .resizable({
        inertia: false,
        preserveAspectRatio: false,
        // restrict two edges
        edges: {
          left: true,
          right: true,
          bottom: true,
          top: true
        },
        restrict: {
          restriction: screen,
          endOnly: false
        },
        snap: {
          targets: [
            interact.createSnapGrid({ x: 5, y: 5 })
          ],
          range: Infinity,
          relativePoints: [ { x: 0, y: 0 } ]
        },
        enabled: true,
        invert: 'none',
        onmove: function (event) {
          if (event.type === 'resizemove') {
            vue.updateScreenCords(event, 'resize')
            // vue.$dispatch('resizemove', event)
          }
        },
        onend: function (event) {
          if (event.type === 'resizeend') {
            vue.updateScreenCords(event, 'update', FROM_RESIZE)
          }
        }
      })
      .draggable({
        // disable inertia throwing
        inertia: false,
        // keep the element within the area of it's parent
        restrict: {
          restriction: screen,
          endOnly: true,
          elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
        },
        snap: {
          targets: [
            interact.createSnapGrid({ x: 5, y: 5 })
          ],
          range: Infinity,
          relativePoints: [ { x: 0, y: 0 } ]
        },
        autoScroll: false,
        onstart: function (event) {
        },
        onmove: function (event) {
          if (event.type === 'dragmove') {
            vue.updateScreenCords(event, 'drag')
          }
        },
        onend: function (event) {
          console.log('drag end')
          if (event.type === 'dragend') {
            vue.updateScreenCords(event, 'update', FROM_DRAG)
          }
        }
      }).gesturable({
        restrict: {
          restriction: screen,
          endOnly: true
        },
        maxPerElement: 1,
        onstart: function (event) {
          if (event.type === 'gesturestart') {
            vue.event = event.type
            let target = event.target
            // set the original x, y , width , height of the box
            target.setAttribute('data-bWidth', event.box.width)
            target.setAttribute('data-bHeight', event.box.height)
            target.setAttribute('data-bPreviousX', event.box.x)
            target.setAttribute('data-bPreviousY', event.box.y)
          }
        },
        onmove: function (event) {
          if (event.type === 'gesturemove') {
            vue.event = event.type
            vue.updateScreenCords(event, 'gesture')
          }
        },
        onend: function (event) {
          if (event.type === 'gestureend') {
            vue.updateScreenCords(event, 'update', FROM_GESTURE)
          }
        }
      })
    }, // close this.interact
    // Functions that name of it started with _ are used in render screen
    _getSplitSize (screen, screenWidth, screenHeight) {
      // Set screen width and height and posArray
      $(screen).css('width', screenWidth + 'px')
      $(screen).css('height', screenHeight + 'px')
      // get split and let input to specific size
      if (this.outLayout === 'quick') {
      } else if (this.outLayout === 'full') {
      } else if (this.outLayout === 'custom') {
      } else if (this.outLayout === 'init') {
      }
    },
    _operateCSS (screenWidth, screenHeight) {
      if (this.outLayout === 'quick') {

      } else if (this.outLayout === 'full') {
      } else if (this.outLayout === 'init' || this.outLayout === 'custom') {
        let targetSplits = {}
        // need another sets of the ratios to present profiles
        if (this.inProfile) {
          targetSplits = this.profiles[this.id].split
        } else {
          targetSplits = this.splits
        }
        let sizeAry = []
        let toSmall = this.inProfile ? this.presetRatios[this.id][3] / this.presetRatios[this.id][2] : this.inRatio[3] / this.inRatio[2]
        for (let windowID in targetSplits) {
          let size = {
            width: Math.round((targetSplits[windowID][2] - targetSplits[windowID][0]) * toSmall),
            height: Math.round((targetSplits[windowID][3] - targetSplits[windowID][1]) * toSmall)
          }
          sizeAry.push(size)
        }
        let query = '#screen' + this.id + ' .resizable'

        $.each($(query), function (i, val) {
          if (sizeAry.length !== 0) {
            $(val).width(sizeAry[i].width)
            $(val).height(sizeAry[i].height)
            val.style.webkitTransform = val.style.transform = 'translate(' + Math.round(targetSplits[i + 1][0] * toSmall) + 'px,' + Math.round(targetSplits[i + 1][1] * toSmall) + 'px)'
            $(val).attr('data-x', Math.round(targetSplits[i + 1][0] * toSmall))
            $(val).attr('data-y', Math.round(targetSplits[i + 1][1] * toSmall))
          }
        })
        // query = '#screen' + this.id + ' .resizable[data-index='
      }
    },
    renderScreen () {
      console.log('haha renderScreen', this.id)
      this.$store.commit('UPDATE', {
        type: 'inRatio'
      })
      let query = '#screen' + this.id + ' .screen'
      let query2 = '#screen' + this.id + ' .resizable'
      $(query).css({transition: 'all .3s'})
      $.each($(query2), function (i, val) {
        $(val).css({
          transition: 'all .7s ease'
        })
      })
      const screen = this.$els.screen
      const screenWidth = this.inRatio[0] * this.inRatio[3]
      const screenHeight = this.inRatio[1] * this.inRatio[3]

      this._getSplitSize(screen, screenWidth, screenHeight)
      this._operateCSS(screenWidth, screenHeight)
      setTimeout(function () {
        $(query).css({transition: ''})
        $.each($(query2), function (i, val) {
          $(val).css({
            transition: ''
          })
        })
      }, 1000)
      this.interact()
    },
    updateScreenCords (event, type, from) {
      if (!type) return console.log('need to give it a type')
      const target = event.target

      if (type === 'drag') {
        let x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
        let y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy

        // translate the element
        target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px, ' + y + 'px)'

        // update the posiion attributes
        target.setAttribute('data-x', x)
        target.setAttribute('data-y', y)
        // px => number
        let width = parseInt(target.style.width.replace('px', ''))
        let height = parseInt(target.style.height.replace('px', ''))

        this.updateSplitData(target.getAttribute('data-index'), x, y, width, height)
      } else if (type === 'resize') {
        let limit = 10 // limit percent of resizing

        const screenWidth = this.inRatio[0] * this.inRatio[3]
        const screenHeight = this.inRatio[1] * this.inRatio[3]
        // const limitX = this.inRatio[0] * this.inRatio[2]
        // const limitY = this.inRatio[1] * this.inRatio[2]
        // const toRealCords = this.inRatio[2] / this.inRatio[3]

        let x = (parseFloat(target.getAttribute('data-x')) || 0)
        let y = (parseFloat(target.getAttribute('data-y')) || 0)
        // px to number
        let width = parseInt(target.style.width.replace('px', ''))
        let height = parseInt(target.style.height.replace('px', ''))

        // update the element's style
        if (event.rect.width > screenWidth / limit) {
          target.style.width = event.rect.width + 'px'
          width += event.deltaRect.width
          x += event.deltaRect.left

          if ((x + width) > screenWidth) width = screenWidth - x

          target.setAttribute('data-x', x)
        }
        if (event.rect.height > screenHeight / limit) {
          target.style.height = event.rect.height + 'px'
          height += event.deltaRect.height
          y += event.deltaRect.top

          if ((y + height) > screenHeight) height = screenHeight - y

          target.setAttribute('data-y', y)
        }

        target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px,' + y + 'px)'

        this.updateSplitData(target.getAttribute('data-index'), x, y, width, height)
      } else if (type === 'gesture') {
        let limit = 10 // limit percent of resizing

        const screenWidth = this.inRatio[0] * this.inRatio[3]
        const screenHeight = this.inRatio[1] * this.inRatio[3]

        // get the original x, y , width , height of the target
        let x = (parseFloat(target.getAttribute('data-x')) || 0)
        let y = (parseFloat(target.getAttribute('data-y')) || 0)
        // px to number
        let width = parseInt(target.style.width.replace('px', ''))
        let height = parseInt(target.style.height.replace('px', ''))

        // // get previous box
        let bPreviousX = parseInt(target.getAttribute('data-bPreviousX'))
        let bPreviousY = parseInt(target.getAttribute('data-bPreviousY'))
        let bWidth = parseInt(target.getAttribute('data-bWidth'))
        let bHeight = parseInt(target.getAttribute('data-bHeight'))

        // update the element's style
        if (width > screenWidth / limit) {
          width += event.box.width - bWidth
          if (width > screenWidth) width = screenWidth
          x += event.box.x - bPreviousX
          if (x < 0) x = 0
          if ((x + width) > screenWidth) x = screenWidth - width
          target.style.width = width + 'px'
          target.setAttribute('data-x', x)
          target.setAttribute('data-bPreviousX', event.box.x)
          target.setAttribute('data-bWidth', event.box.width)
        }
        if (height > screenHeight / limit) {
          height += event.box.height - bHeight
          if (height > screenHeight) height = screenHeight
          y += event.box.y - bPreviousY
          if (y < 0) y = 0
          if ((y + height) > screenHeight) y = screenHeight - height
          target.style.height = height + 'px'
          target.setAttribute('data-y', y)
          target.setAttribute('data-bPreviousY', event.box.y)
          target.setAttribute('data-bHeight', event.box.height)
        }
        // translate when resizing from top or left edges
        target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px,' + y + 'px)'

        this.updateSplitData(target.getAttribute('data-index'), x, y, width, height)
      } else if (type === 'update') {
        if (this.is4K) {
          this.$store.commit('check4KLimit', {
            index: this.windowFocus,
            type: from
          })
        }
        this.applySplitData()
      }
    },
    applySplitData () {
      call(this.$route.params.mac, 'dxSetSplitArea', {
        split: {
          [this.windowFocus]: this.splits[this.windowFocus]
        }
      }).then(res => {
        console.log('res in drag end', res)
        this.setLayoutChanged(true)
      }).catch(err => {
        console.error('err in drag end', err)
      })
    },
    // To update the splits cords
    updateSplitData (index, x, y, width = null, height = null) {
      let splits = _.cloneDeep(this.splits)

      splits[index][0] = Math.round(x * this.inRatio[2] / this.inRatio[3])
      splits[index][1] = Math.round(y * this.inRatio[2] / this.inRatio[3])

      let limitX = this.inRatio[0] * this.inRatio[2]
      let limitY = this.inRatio[1] * this.inRatio[2]
      // 差距在一定範圍內直接讓他跟原本座標一樣
      if (Math.abs(Math.round((x + width) * this.inRatio[2] / this.inRatio[3]) - limitX) < 5) {
        splits[index][2] = limitX
      } else {
        splits[index][2] = Math.round((x + width) * this.inRatio[2] / this.inRatio[3])
      }

      if (Math.abs(Math.round((y + height) * this.inRatio[2] / this.inRatio[3]) - limitY) < 5) {
        splits[index][3] = limitY
      } else {
        splits[index][3] = Math.round((y + height) * this.inRatio[2] / this.inRatio[3])
      }
      // no smaller than zero
      if (splits[index][0] < 0) splits[index][0] = 0
      if (splits[index][1] < 0) splits[index][1] = 0

      this.$store.commit('UPDATE', {
        type: 'split',
        splitArea: {
          split: splits
        }
      })
    },
    setLayoutChanged (changed) {
      this.$store.commit('UPDATE', {
        type: 'layoutChanged',
        isLayoutChanged: changed
      })
    }
  }, // close methods
  ready () {
    // console.log('vw screen', this.id)
  },
  watch: {
    inRatio (nV) {
    }
  },
  events: {
    render (key) {
      if (key === this.id || key === 'all') {
        this.renderScreen()
      }
    },
    chgResolution () {
      this.outLayout = 'quick'
      this.quickSelectSplit = '2*2'
      this.renderScreen()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~__vendor_variables_scss__';
@import '~sass/_breakpoint.scss';

$layout_border_width: 3px;

.screen{
  position: relative;
  background-color: $Screen_bg;
  // border: 1px solid $Screen_border;
  box-sizing:border-box;
  margin-top: $space_xxs;
  margin-bottom: 0px;
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
  // border: 1px solid #000;
  width: 400px;
  height: 300px;
  & ::selection{
    background-color: transparent;
  }
}
.editable .resizable{

  & .window_pointer{
    display:block;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    width:25px;
    height:25px;
    font-size: 25px;
  }
  & .innerMask{
    background-color: rgba(255,255,255,0.7);
  }
  &.focus{
    font-family: FontAwesome;
    /* .main_title_bar z-index is 20 , set .focus smaller than it*/
    z-index: 19;
    .innerMask{
      background-color: transparent;
    }
    .label_group {
      color: $base_white;
    }
    outline: $layout_border_width solid #000;
    outline-offset: -($layout_border_width);
    &:before, &:after{
      content: '';
      display:block;
      width:100%;
      height:10px;
      position: absolute;
      border-left: 10px solid #000;
      border-right: 10px solid #000;
      left:0;
    }
    &:before{
      top:0px;
    }
    &:after{
      bottom:0px;
    }
    &[data-bdColor='1']{
      &:before, &:after{
        border-color: $window_a;
      }
      outline: $layout_border_width solid $window_a;
      .label_group {
        background-color:$window_a;
      }
    }
    &[data-bdColor='2']{
      &:before, &:after{
        border-color: $window_b;
      }
      outline: $layout_border_width solid $window_b;
      .label_group {
        background-color:$window_b;
      }
    }
    &[data-bdColor='3']{
      &:before, &:after{
        border-color: $window_c;
      }
      outline: $layout_border_width solid $window_c;
      .label_group {
        background-color:$window_c;
      }
    }
    &[data-bdColor='4']{
      &:before, &:after{
        border-color: $window_d;
      }
      outline: $layout_border_width solid $window_d;
      .label_group {
        background-color:$window_d;
      }
    }
  }
}
.resizable{
  &.border{
    outline:$layout_border_width solid #000;
    outline-offset: -($layout_border_width);
    &[data-bdColor='1']{
      outline: $layout_border_width solid $window_a;
    }
    &[data-bdColor='2']{
      outline: $layout_border_width solid $window_b;
    }
    &[data-bdColor='3']{
      outline: $layout_border_width solid $window_c;
    }
    &[data-bdColor='4']{
      outline: $layout_border_width solid $window_d;
    }
    &.border_ani{
      @keyframes blink {
        50% {
          outline: none;
        }
      }
      animation: blink 1s 0s infinite linear;
    }
  }
  overflow:hidden;
  position: absolute;
  & .label_group{
    position: absolute;
    top: 6%;
    left: 10%;
    display:block;
    width:auto;
    height:20px;
    text-align:center;
    padding: 0 3px;
    white-space:nowrap;
    @include breakpoint(iFive) {
      height:15px;
      font-size: 10px;
    }
  }
  &:nth-of-type(even) {
    & .label_group{
      left:5%;
    }
  }
  .innerMask{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    width:100%;
    height:100%;
  }
  & img{
    width: 100%;
    height: 100%;
  }
  // &[data-bdColor='1']{
  //   background-color: $window_a;
  // }
  // &[data-bdColor='2']{
  //   background-color: $window_b;
  // }
  // &[data-bdColor='3']{
  //   background-color: $window_c;
  // }
  // &[data-bdColor='4']{
  //   background-color: $window_d;
  // }

  .showWindowBtn{
    background-color: $base_black;
    color: $base_white;
    position: absolute;
    right: 10px;
    bottom: 10px;
    z-index: 2;
  }
}

.inProfile .label_group{
  font-size: 50%;
}

.mask, .link_mask{
  position: absolute;
  z-index: 1000;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  width: 100%;
  height: 100%;
  background-color: transparent;
}

.ps{
  width: 100%;
  display:inline-block;
  text-align:center;
}
//
// .forDev{
//   position: absolute;
//   top: 10px;
//   left:10px;
//   background-color: #fff;
//   z-index: 10000;
// }

.bg{
  width:100%;
  height:100%;
  position: absolute;
}
.inProfile .bg {
  left: 0;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// VWScreen.vue?54392b13